import { Component, ElementRef, ViewChild } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import {MenuServiceInt} from "@core/_services/menu.serviceint";
import { AuthService } from '@auth/auth.service';
import { Router } from '@angular/router';
import { NotificationsComponent } from '@documalis/notifications';
import { NotificationService } from '@service/notification.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrls: ['./app.topbar.custom.scss']
})
export class AppTopbarComponent {
    
    @ViewChild('menuButton') menuButton!: ElementRef;

    @ViewChild('mobileMenuButton') mobileMenuButton!: ElementRef;

    @ViewChild('searchInput') searchInput!: ElementRef;

    @ViewChild('notify') notify: NotificationsComponent;

    public isAdmin: boolean = false;
    public adminMenu = [];
    public clickNotification = false;
    
    constructor(public layoutService: LayoutService, public el: ElementRef, public menu: MenuServiceInt, 
        private auth: AuthService, private _router: Router,
        public notifService: NotificationService) {
        this.isAdmin = this.auth.isAdmin();
        this.adminMenu = this.menu.getAdminMenuElem(this.isAdmin);
    }

    activeItem!: number;

    get mobileTopbarActive(): boolean {
        return this.layoutService.state.topbarMenuActive;
    }

    public navigate(aLink) {
        this._router.navigate(aLink);
    }

    public clickNotif() {        
        this.clickNotification = !this.clickNotification;
        if (this.clickNotification === true) {            
            this.notify.setNotifList();
            this.notifService.notifyCount = 0;
        }
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onRightMenuButtonClick() {
        this.layoutService.openRightSidebar();
    }

    onMobileTopbarMenuButtonClick() {
        this.layoutService.onTopbarMenuToggle();
    }

    focusSearchInput(){
       setTimeout(() => {
         this.searchInput.nativeElement.focus()
       }, 0);
    }
}
